module.exports = __webpack_public_path__ + "img/logowu.9f57fa1a.png";